// Lista canónica de tipos primitivos DMN/FEEL soportados por la UI.
// Mantenida en un solo lugar para que panel + tabla + expression
// rendericen exactamente las mismas opciones.
//
// Incluye los tipos built-in de DMN 1.3 (forma XSD-QName) más `number` y `any`
// como aliases pragmáticos usados por la UI existente.
export const FEEL_TYPES = [
  'string',
  'number',
  'boolean',
  'integer',
  'double',
  'long',
  'date',
  'time',
  'dateTime',
  'duration',
  'yearMonthDuration',
  'dayTimeDuration',
  'any',
];
